import { request } from '@/libs/api-request'

export function scenarioRun (params) {
  const url = 'probe/run'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export function probeRunCheck () {
  const url = 'probe/check_run'
  const config = {
    method: 'get',
    url
  }
  return request(config, true)
}

export function getTestList () {
  const url = 'probe/test_case_list'
  const config = {
    method: 'get',
    url
  }
  return request(config, true)
}

export function getScenarioList () {
  const url = 'probe/scenario_result_list'
  const config = {
    method: 'get',
    url
  }
  return request(config, true)
}

export function getTestResultList (params) {
  const url = 'probe/case_result_list'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}
